import React from "react";
import { Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Route, RouteComponentProps, Switch } from "react-router";
import EmptyData from "go-core/components/EmptyData";
import { LoadingContainer } from "go-core/components/Loading";
import { ApplicationApi, ApplicationTemplateApi } from "../../../../../../../../../../services/Api/Organization/types";
import OrganizationAppsEditIndexPage from "../../../../pages/Edit/pages/Index";
import OrganizationAppsEditLogsPage from "../../../../pages/Edit/pages/Logs";
import { AppModalViewMode, AppState } from "../../../../utils/types";
import AppForm from "../../AppForm";
import RenderAppErrors from "../../RenderAppErrors";
import RenderAppWarnings from "../../RenderAppWarnings";

interface Props {
	installedApp?: ApplicationApi;
	appState: AppState | undefined;
	routeProps?: RouteComponentProps;
	viewMode: AppModalViewMode;
	configApp: ApplicationTemplateApi;
	handleUpdate?: (app: ApplicationApi) => void;
	setAppState: React.Dispatch<React.SetStateAction<AppState | undefined>>;
	fetchApplication: () => Promise<void>;
}

const AppModalBodyRoutes = ({
	installedApp,
	routeProps,
	appState,
	viewMode,
	configApp,
	handleUpdate,
	setAppState,
	fetchApplication,
}: Props) => {
	const renderAppErrors = appState?.app?.errors && appState?.app?.errors.filter((f) => f.code).length > 0;
	const renderAppWarnings = appState?.app?.dangers && appState?.app?.dangers.filter((f) => f.code).length > 0;
	const { t } = useTranslation();

	return (
		<>
			{installedApp ? (
				<Switch>
					<Route
						path={`${routeProps?.match.url}/logs`}
						render={() => <OrganizationAppsEditLogsPage appId={installedApp.id} />}
					/>
					<Route
						exact
						path={routeProps?.match.url}
						render={() => (
							<OrganizationAppsEditIndexPage>
								{renderAppErrors && <RenderAppErrors errors={appState.app.errors} />}
								{renderAppWarnings && <RenderAppWarnings dangers={appState.app.dangers} />}
								{viewMode === AppModalViewMode.DESCRIPTION && (
									<Card>
										<Card.Body>
											<div
												dangerouslySetInnerHTML={{
													__html: configApp.long_description,
												}}
											/>
										</Card.Body>
									</Card>
								)}
								{viewMode === "START" && (
									<Card>
										<Card.Body>
											<div
												dangerouslySetInnerHTML={{
													__html: configApp.help_description,
												}}
											/>
										</Card.Body>
									</Card>
								)}
								{viewMode === "FORM" && (
									<>
										{!appState ? (
											<LoadingContainer />
										) : (
											<AppForm
												appState={appState}
												handleUpdateApp={handleUpdate}
												provider={configApp.provider}
												setAppState={setAppState}
												fetchApplication={fetchApplication}
											/>
										)}
									</>
								)}
							</OrganizationAppsEditIndexPage>
						)}
					/>
				</Switch>
			) : (
				<>
					{viewMode === "DESCRIPTION" && (
						<Card>
							<Card.Body>
								<div
									dangerouslySetInnerHTML={{
										__html: configApp.long_description,
									}}
								/>
							</Card.Body>
						</Card>
					)}
					{viewMode === "START" && (
						<Card>
							<Card.Body>
								<div
									dangerouslySetInnerHTML={{
										__html: configApp.help_description,
									}}
								/>
							</Card.Body>
						</Card>
					)}
					{viewMode === "EMPTY" && (
						<EmptyData title={t("modules.app.field.empty.title")} styles={{ background: "#e6e6e6" }} />
					)}
				</>
			)}
		</>
	);
};

export default AppModalBodyRoutes;
